import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
/**
 * The API key is never part of this structure: it only exists on the server.
 */
export class MailchimpSettings extends AutoEncoder {
    accountName = '';
    /**
     * Mailchimp datacenter prefix, e.g. 'us21'
     */
    dataCenter = '';
    audienceId = null;
    audienceName = null;
    /**
     * Record that members use to opt in to the newsletter.
     * When set, only contacts with at least one linked member who opted in are added.
     */
    newsletterRecordId = null;
    /**
     * For choice records: the choices that count as opting in
     */
    newsletterChoiceIds = [];
    /**
     * Records whose answers are sent to Mailchimp as tags
     */
    tagRecordIds = [];
}
__decorate([
    field({ decoder: StringDecoder })
], MailchimpSettings.prototype, "accountName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MailchimpSettings.prototype, "dataCenter", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], MailchimpSettings.prototype, "audienceId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], MailchimpSettings.prototype, "audienceName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], MailchimpSettings.prototype, "newsletterRecordId", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], MailchimpSettings.prototype, "newsletterChoiceIds", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], MailchimpSettings.prototype, "tagRecordIds", void 0);
//# sourceMappingURL=MailchimpSettings.js.map